import React from 'react';
import { edit, locked } from '../../../assets/images/dashboard-business';
import { TStep4Info, TStep6Info } from '../../../types';

type TProps = {
  info: TStep4Info;
  info6: TStep6Info;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};
const PartnerFinalForm = ({ info, info6, setStep }: TProps) => {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  const birthDate: any = info?.birthDate;

  return (
    <div>
      <div className='mb-3 mt-3 flex gap-[60px]'>
        {/* <div> */}
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            First name
          </div>
          <div>{info?.firstName}</div>
        </div>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Nationality
          </div>
          <div>{info?.nationality}</div>
        </div>
        {/* </div> */}
        <div>
          <img src={edit} alt='edit' onClick={() => setStep(4)} />
        </div>
      </div>

      <div className='mb-3 flex gap-[60px]'>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Last name
          </div>
          <div>{info?.lastName}</div>
        </div>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Gender
          </div>
          <div>{info?.gender}</div>
        </div>
        {/* <div>
                <img src={edit} alt='edit'/>
            </div> */}
      </div>

      <div className='mb-3 flex gap-[60px]'>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Other names
          </div>
          <div>{info?.otherName}</div>
        </div>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Email Address
          </div>
          <div>{info?.businessEmail}</div>
        </div>
        {/* <div>
                <img src={edit} alt='edit'/>
            </div> */}
      </div>

      <hr />

      <div className='mt-3 mb-3 flex gap-[60px]'>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Identity type
          </div>
          <div>{info?.identityType}</div>
        </div>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Identity Number
          </div>
          <div>{info?.identityNumber}</div>
        </div>
        <div>
          <img src={edit} alt='edit' onClick={() => setStep(4)} />
        </div>
      </div>
      <div className='mb-3 flex gap-[60px]'>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Occupation
          </div>
          <div>{info?.occupation}</div>
        </div>
        <div className='w-[200px] mb-3'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Phone number
          </div>
          <div>{info?.bvnPhone}</div>
        </div>
        {/* <div>
                <img src={edit} alt='edit'/>
            </div> */}
      </div>
      <div className='mb-3 flex gap-[60px]'>
        {/* <div className='w-[200px] mb-3 opacity-25'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            Date of Birth
          </div>
          <div>{birthDate?._d}</div>
        </div> */}
        <div className='w-[200px] mb-3 opacity-25'>
          <div className='text-[16.404px] text-[500] leading-[22px] text-[#005555] mb-[10px]'>
            BVN number
          </div>
          <div>{info?.bvn}</div>
        </div>
        <div className='opacity-25'>
          <img src={locked} alt='edit' />
        </div>
      </div>

      {/* IMAGES */}
      {info6.passport && (
        <div className='flex gap-5 mb-3 items-center'>
          <img
            src={URL.createObjectURL(info6?.passport)}
            alt='checkedImg'
            className='h-[200px] w-[220px]'
          />
          <div className='bg-[#F4F4F4] py-2 px-3 rounded--md' onClick={() => setStep(6)}>
            Replace
          </div>
        </div>
      )}
      {info6.idCard && (
        <div className='flex gap-5 mb-3 items-center'>
          <img
            src={URL.createObjectURL(info6?.idCard)}
            alt='checkedImg'
            className='h-[200px] w-[220px]'
          />
          <div className='bg-[#F4F4F4] py-2 px-3 rounded--md' onClick={() => setStep(6)}>
            Replace
          </div>
        </div>
      )}
      {info6.proofOfAddress && (
        <div className='flex gap-5 mb-3 items-center'>
          <img
            src={URL.createObjectURL(info6?.proofOfAddress)}
            alt='checkedImg'
            className='h-[200px] w-[220px]'
          />
          <div className='bg-[#F4F4F4] py-2 px-3 rounded--md' onClick={() => setStep(6)}>
            Replace
          </div>
        </div>
      )}
      {info6.signature && (
        <div className='flex gap-5 mb-3 items-center'>
          <img
            src={URL.createObjectURL(info6?.signature)}
            alt='checkedImg'
            className='h-[200px] w-[220px]'
          />
          <div className='bg-[#F4F4F4] py-2 px-3 rounded--md' onClick={() => setStep(6)}>
            Replace
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerFinalForm;
